<template>
  <div class="page-column">
    <div class="common-type-list">
      <div
        class="type-item"
        :class="{ active: contIndex == 0 }"
        @click="selectEvent(0)"
      >
        大V专栏
      </div>
      <div
        class="type-item"
        :class="{ active: contIndex == 1 }"
        @click="selectEvent(1)"
      >
        主题专栏
      </div>
    </div>
    <div class="column-cont">
      <div class="clearfix" v-if="contIndex == 0">
        <div class="dav-item" v-for="(item, index) in VData" :key="index">
          <router-link
            :to="{ path: '/column/davart', query: { id: item.userId } }"
          >
            <div class="user-avatar">
              <img :src="item.imgUrl" alt="" />
            </div>
            <div class="user-name over-e">
              <div>{{ item.userName }}</div>
            </div>

            <div
              class="new-chenghao clearfix"
              v-if="item.userRankName != '' && item.userRankName != null"
            >
              <i
                class="icon zs"
                v-if="item.userRankName.split(',')[1] == '资深作者'"
              ></i>
              <i
                class="icon yx"
                v-if="item.userRankName.split(',')[1] == '优秀作者'"
              ></i>
              <i
                class="icon hy"
                v-if="item.userRankName.split(',')[1] == '活跃作者'"
              ></i>
              <span class="zuoz">{{ item.userRankName.split(",")[1] }}</span>
              <span class="shu">|</span>
              <span class="liny">{{ item.userRankName.split(",")[0] }}</span>
            </div>

            <!--<div class="new-chenghao clearfix">-->
            <!--<i class="icon zs"></i>-->
            <!--<span class="zuoz">资深作者</span>-->
            <!--<span class="shu">|</span>-->
            <!--<span class="liny">动画领域</span>-->
            <!--</div>-->

            <div class="qianming over-e">{{ item.signature }}</div>
          </router-link>
          <div class="news-articles">
            <div class="tit">最新文章</div>
            <ul class="list" v-if="item.archiveList.length > 0">
              <li
                v-for="(item_bak, index_bak) in item.archiveList"
                :key="index_bak"
              >
                <div class="item-title">
                  <router-link
                    :to="{
                      path: '/column/davdetail',
                      query: { id: item_bak.id }
                    }"
                    :title="item_bak.archiveTitle"
                    target="_blank"
                    >{{ item_bak.archiveTitle }}</router-link
                  >
                </div>
                <span class="date">{{ item_bak.showTime }}</span>
              </li>
              <!--              <li>-->
              <!--                <div class="item-title">-->
              <!--                  <router-link to="/column/davdetail">文章标题文章标题文章标题文章标题文章标题文章标题</router-link>-->
              <!--                </div>-->
              <!--                <span class="date">2019/12/15</span>-->
              <!--              </li>-->
            </ul>
            <div class="empty-list" v-else>暂无文章^_^</div>
          </div>
        </div>
      </div>

      <div class="clearfix" v-if="contIndex == 1">
        <div
          class="theme-item"
          v-for="(item, index) in columnData"
          :key="index"
        >
          <router-link
            :to="{ path: '/column/themeart', query: { id: item.id } }"
            class="img-f"
            :style="{ backgroundImage: 'url(' + item.columnCover + ')' }"
          ></router-link>
          <div class="infoes">
            <div class="tit">
              <router-link
                :to="{ path: '/column/themeart', query: { id: item.id } }"
                >{{ item.columnName }}</router-link
              >
            </div>
            <div v-if="item.archiveList.length > 0">
              <div class="date">
                {{ item.archiveList[0].createTime | formatTime }}更新
              </div>
            </div>
          </div>
          <ul class="art-list">
            <div v-if="item.archiveList.length > 0">
              <li
                class="art-item"
                v-for="(item_bak, index_bak) in item.archiveList"
                :key="index_bak"
              >
                <div class="left-tit">
                  <router-link
                    :to="{
                      path: '/column/themedetail',
                      query: { id: item_bak.id }
                    }"
                    :title="item_bak.archiveTitle"
                    target="_blank"
                    >{{ item_bak.archiveTitle }}</router-link
                  >
                </div>
                <div class="right-user clearfix">
                  <router-link
                    :to="{
                      path: '/column/themedetail',
                      query: { id: item_bak.id }
                    }"
                    target="_blank"
                    class="avatar"
                    ><img :src="item_bak.imgUrl" alt=""
                  /></router-link>
                  <div class="name">
                    <router-link
                      :to="{
                        path: '/home',
                        query: { userId: item_bak.creatorId }
                      }"
                      target="_blank">{{
                      item_bak.creatorName
                    }}</router-link>
                  </div>
                </div>
              </li>
            </div>

            <div class="empty-list" v-else>暂无文章^_^</div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  //import archiveApi from '@/api/archive'
  //import axios from 'axios';
  import updateTdk from "@/utils/tdk";
  import columnApi from '@/api/column'
  import userInfoApi from '@/api/userInfo'
  import {mapState} from "vuex";
export default {
  components: {

  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    return this.fetchData();

  },
  beforeRouteUpdate(to, from, next) {
    // 一般建议路由变更采用计算属性或者store直接绑定
    // 特殊情况处理可以采用如下方案 重新注册数据返回处理
    this.search()
    next();
  },
  data () {
    return {
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      nullParam:{},
      listLoading:false,
      contIndex: 0,
      VData:[],
      columnData:[],
      tableData:[],
      columnParam: {
        creatorId:null,
        columnName: null,
        columnType:2,
      },
      TagParam: {
        creatorId:null,
        archiveTitle: null,
        pageIndex: 1,
        pageSize: 12,
        columnId:0,
        columnType:0,

        auditStatus:'-2',
        publishStatus:'',

      },
    }
  },
  computed: {
    ...mapState(["columnMeta"])
  },
  mounted(){
    let _this=this;

    if(_this.$route.query.type==undefined){
      window.open("/columnall?type=0",'_self')
    }else{
      _this.contIndex = _this.$route.query.type
      console.log("this.contIndex",_this.contIndex)
    }
    _this.search()
    // let index = this.$route.params.index
    // if(index){
    //   this.contIndex = index
    // }
    // console.log("this.contIndex===========",this.contIndex)
    _this.isMounted = true;

  },
  methods: {
    fetchData(){

      let id=0;
        if(this.$route.query.type!=undefined){
          id=this.$route.query.type
        }
        return this.$store
            .dispatch("FETCH_COLUMN_META", {
              id: id
            })
            .finally(() => {
              this.$loading(false);
              this.setSeo(9)
              updateTdk.call(this);
            });


    },

    setSeo(type) {
      let thiss = this
      thiss.headTitle = this.columnMeta.title
      thiss.headKeywords = this.columnMeta.keywords;
      thiss.headDesc =this.columnMeta.desc;


    },
    search(){
      let this_ = this
      this_.listLoading = true
      //大V
      if(this.contIndex==0){
        //首先查找大V
        userInfoApi.getList(this_.nullParam).then(reUser => {
          // console.log("reUser===",reUser)
          this_.VData =reUser.response
          // archiveApi.pageList(this_.TagParam).then(re => {
          //   this_.tableData = re.list
          //   this_.total = re.total
          //   this_.TagParam.pageIndex = re.pageNum
          //   this_.listLoading = false
          // })
          //this.title = "test Title"
          //this.description = 'test Desc'
        });

        this_.setSeo(1);
        updateTdk.call(this_);

      }
      //主题
      else{
        columnApi.getList(this_.columnParam).then(reColumn =>{
          // console.log("reColumn===",reColumn)
          this_.columnData = reColumn.response
          // this_.TagParam.columnType =1
          // archiveApi.pageList(this_.TagParam).then(re => {
          //   this_.tableData = re.list
          //   this_.total = re.total
          //   this_.TagParam.pageIndex = re.pageNum
          //   this_.listLoading = false
          // })
        })

        this_.setSeo(2);
        updateTdk.call(this_);
      }
    },

    selectEvent (index) {
      // this.contIndex = index
      // this.search()
      window.open("/columnall?type="+index,'_self')
      // this.contIndex = index

      // this.fetchData()


    },
    toList(cId){
      // console.log("cId==",cId)
      this.$router.push({
        path:'/column/themeart',
        query: {id:cId}
      })
      //window.open('/#/column/themeart?id='+cId, '_blank');
    },
  }
}
</script>

<style scoped lang="less">
.page-column {
  padding-top: @NAVHEIGHT;
  .common-type-list {
    padding-top: 20px;
  }
}
//@import "../../assets/less/stylePublic.less";
</style>
